import { EmptyState, Flex } from '@cad-arc';

export function FailedToLoadError({ noun }: { noun: string }) {
    return (
        <Flex justifyContent="center" alignItems="center" h="100%" w="100%">
            <EmptyState
                title={`Failed to load ${noun}`}
                subtitle="Try again later or contact IT for support"
                visual="Alert"
            />
        </Flex>
    );
}
